import { Spin } from 'antd'
import React from 'react'
import * as locCon from "../LocalConstants"


function CustomSpin({ type, ...props }) {

    switch (type) {
        case locCon.BUTTON_SPINNER:
            return (<div style={{ marginBottom: "3vh" }}>
                <Spin {...props} />
            </div>)
        case locCon.SMALL_SPINNER:
            return (<Spin {...props} />)
        default:
            return (<div style={{ marginBottom: "3vh" }}>
                <Spin {...props} />
            </div>)
    }


}


export default CustomSpin